import React, { useState, useRef } from 'react';
import { Spin, Affix } from 'antd';
import ThemeEmpty from '@base/lib/ThemeEmpty'
import ResultsInfoMsg from '@pro/activity/testerClub/ResultsContent/ResultsInfoMsg'
import ResultsProduct from '@pro/activity/testerClub/ResultsContent/ResultsProduct'
import ResultsSelected from '@pro/activity/testerClub/ResultsContent/ResultsSelected';
import ResultsComeingSoon from '@pro/activity/testerClub/ResultsContent/ResultsComeingSoon';
import { useEarlyAccessResultsModal } from '@pro/activity/testerClub/useEarlyAccessResultsModal';
import { IListItem, IResultViewType } from '@pro/activity/testerClub/interface';
import ResultsTesterReviews from '@app/activity/testerClub/ResultsTesterReviews';
import ReviewButton from '@pro/activity/testerClub/ResultsContent/ReviewButton';

type IProps = {
    product: IListItem;
    viewType?: IResultViewType;
}

const ModalContent: React.FC<IProps> = (props) => {
    const { product, viewType } = props

    const results = useEarlyAccessResultsModal({ product })

    const hasActivityGid = results.resultsData?.activityGid
    // 已公布名单
    const hasEmails = !!results.resultsData?.emails.length
        || results.resultsData?.hasResult

    // 用户已参加 || 中奖
    const userParticipated = !!results.resultsData?.userParticipated
        || !!results.resultsData?.userSelected

    return (
        <div className={'relative'}>
            <Spin spinning={results.isLoading}>
                {!hasActivityGid ? <ThemeEmpty/> : (
                    <>
                        {(userParticipated && hasEmails) && (
                            <ResultsInfoMsg results={results}/>
                        )}

                        <ResultsProduct results={results}/>

                        <ResultsTesterReviews results={results} viewType={viewType}/>

                        {hasEmails ? (
                            <ResultsSelected results={results}/>
                        ) : (
                            <ResultsComeingSoon/>
                        )}

                        {!!results?.resultsData?.userCanReview && (
                            <Affix
                                target={() => document.getElementById('js-results-content')}
                                offsetBottom={10}
                            >
                                <ReviewButton results={results}/>
                            </Affix>
                        )}

                    </>
                )}
            </Spin>
        </div>
    );
};

export default ModalContent